import React from 'react'
import { TransactionalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { makeControlledModal } from 'src/decorators/ModalController'

const ClearCartConfirmationModal = ({  modal, ...props }: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
}) => {
  const { t } = React.useContext(TranslationContext)
  return (
    <TransactionalDialog
      header={t('Clear Cart')}
      body={t('Are you sure you want to remove all items from your shopping cart?')}
      confirmText={t('Delete')}
      {...props}
      {...modal}
    />
  )
}

export default makeControlledModal(ClearCartConfirmationModal, 'ClearCartConfirmationModal')
